module.exports = __webpack_public_path__ + "static/media/back.97591c79.jpg";